var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgClockPartialCircle = function SvgClockPartialCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.0454V20.4999",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8218 24.7273L19.5 20.5",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.393 15.5182H36.4384V8.47278",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4601 31.4602C28.2924 33.6279 25.5306 35.1041 22.5239 35.7022C19.5172 36.3002 16.4007 35.9933 13.5684 34.8201C10.7361 33.647 8.31538 31.6603 6.61222 29.1113C4.90906 26.5624 4 23.5656 4 20.5C4 17.4344 4.90906 14.4376 6.61222 11.8887C8.31538 9.3397 10.7361 7.35303 13.5684 6.17987C16.4007 5.00672 19.5172 4.69976 22.5239 5.29783C25.5306 5.89591 28.2924 7.37214 30.4601 9.53985L36.4384 15.5181",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgClockPartialCircle);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjUgMTIuMDQ1NFYyMC40OTk5IiBzdHJva2U9IiMwNTRCQzciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI2LjgyMTggMjQuNzI3M0wxOS41IDIwLjUiIHN0cm9rZT0iIzA1NEJDNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuMzkzIDE1LjUxODJIMzYuNDM4NFY4LjQ3Mjc4IiBzdHJva2U9IiMwNTRCQzciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMwLjQ2MDEgMzEuNDYwMkMyOC4yOTI0IDMzLjYyNzkgMjUuNTMwNiAzNS4xMDQxIDIyLjUyMzkgMzUuNzAyMkMxOS41MTcyIDM2LjMwMDIgMTYuNDAwNyAzNS45OTMzIDEzLjU2ODQgMzQuODIwMUMxMC43MzYxIDMzLjY0NyA4LjMxNTM4IDMxLjY2MDMgNi42MTIyMiAyOS4xMTEzQzQuOTA5MDYgMjYuNTYyNCA0IDIzLjU2NTYgNCAyMC41QzQgMTcuNDM0NCA0LjkwOTA2IDE0LjQzNzYgNi42MTIyMiAxMS44ODg3QzguMzE1MzggOS4zMzk3IDEwLjczNjEgNy4zNTMwMyAxMy41Njg0IDYuMTc5ODdDMTYuNDAwNyA1LjAwNjcyIDE5LjUxNzIgNC42OTk3NiAyMi41MjM5IDUuMjk3ODNDMjUuNTMwNiA1Ljg5NTkxIDI4LjI5MjQgNy4zNzIxNCAzMC40NjAxIDkuNTM5ODVMMzYuNDM4NCAxNS41MTgxIiBzdHJva2U9IiMwNTRCQzciIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";